<template>
    <div>
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-alert type="success" style="margin-bottom: 20px;">
                <p style="font-size: 16px;line-height: 30px"> 提现限额每次：1-2000元，提现成功之后及时到账【微信零钱】，大笔金额提现后可联系客服处理
                <br>如未到账请先联系客服，微信：17606035024</p>
            </el-alert>
            <el-row style="margin-bottom: 20px">
                <el-button  size="small" @click="getWarehouses()" :loading="loading">一键刷新</el-button>
            </el-row>
            <el-row :gutter="16">
                <el-col :span="6" v-for="wares in warehouses" :key="wares.id">
                    <CWarehouseAccount :warehouse="wares" />
                </el-col>
            </el-row>
            
        </Content>
    </div>
</template>
<script>
import Constants from "@/utils/constants"
import CWarehouseAccount from "./CWarehouseAccount.vue"
export default {
    name: 'Recharge',
    data() {
        return {
            loading: false,
            warehouses: []

        };
    },
    mounted: function() {
        var me = this;
        // me.refreshBase();
        me.getWarehouses();

    },
    components: {
        CWarehouseAccount
    },
    computed: {

    },
    beforeRouteLeave(to, from, next) {
        next();
    },
    beforeRouteUpdate(to, from, next) {



        next();
    },
    beforeRouteEnter(to, from, next) {

        next();
    },
    methods: {
        getWarehouses: function() {
            var me = this;
            me.loading = true;
            me.$http.post("/ware/warehouse/getall.action", {}).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.warehouses = body.obj;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        }

    }
}
</script>
<style scoped>
.fitem {
    line-height: 3;
    font-size: 14px;
}
</style>